import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';

// light — по умолчанию; system — следовать настройке ОС
const STORAGE_KEY = 'adminTheme';
const ThemeContext = createContext(null);

function readPreference() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === 'light' || saved === 'dark' || saved === 'system') return saved;
  } catch { /* приватный режим */ }
  return 'light';
}

const systemPrefersDark = () => window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;

export function ThemeProvider({ children }) {
  const [preference, setPreferenceState] = useState(readPreference);
  const [systemDark, setSystemDark] = useState(systemPrefersDark);

  useEffect(() => {
    const media = window.matchMedia?.('(prefers-color-scheme: dark)');
    if (!media) return undefined;
    const onChange = (e) => setSystemDark(e.matches);
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, []);

  const isDark = preference === 'dark' || (preference === 'system' && systemDark);

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDark);
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', isDark ? '#09090b' : '#ffffff');
  }, [isDark]);

  const setPreference = useCallback((next) => {
    setPreferenceState(next);
    try { localStorage.setItem(STORAGE_KEY, next); } catch { /* приватный режим */ }
  }, []);

  const value = useMemo(() => ({ preference, setPreference, isDark }), [preference, setPreference, isDark]);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
}

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used inside ThemeProvider');
  return ctx;
}
